export const EXISTED_FIELD = "existed";
export const MIN_VALUE = "000001";
export const MAX_VALUE = "999999";
